import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '../lib/utils';

const badgeVariants = cva(
  'inline-flex items-center justify-center rounded-[25px] px-2 py-0.5 text-[11px] font-medium capitalize leading-[145%] tracking-[0.44px] text-[#41424E]',
  {
    variants: {
      variant: {
        green: 'bg-green-200',
        yellow: 'bg-[#FAE580]',
        // Typographic shape only. Colour belongs to the call site: `cn` is twMerge, so any
        // `bg-*`/`text-*` passed in drops the variant's own — which is what already happened.
        full: 'uppercase tracking-[0.6px]',
      },
    },
    defaultVariants: {
      variant: 'green',
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(({ className, variant, ...props }, ref) => (
  <span ref={ref} className={cn(badgeVariants({ variant, className }))} {...props} />
));
Badge.displayName = 'Badge';

export { Badge, badgeVariants };
